import { useProductVariants } from '../useProductVariants';
import { useStockStatus } from '@jetshop/ui/Stock/StockStatusContainer';
import { useEffect } from 'react';
export function usePackageProductItem(item, updateItem, { preselectCheapest } = {}) {
    var _a;
    const { product } = item;
    const variantHandler = useProductVariants(product, {
        preselectCheapest: preselectCheapest
    });
    const variantValidation = variantHandler.validation;
    const selectedVariantArticleNumber = (_a = variantHandler.selectedVariant) === null || _a === void 0 ? void 0 : _a.articleNumber;
    const stockStatus = useStockStatus(variantHandler.selectedVariant || product);
    useEffect(() => {
        updateItem(product.articleNumber, selectedVariantArticleNumber, variantValidation === 'valid');
    }, [
        product.articleNumber,
        selectedVariantArticleNumber,
        updateItem,
        variantHandler.selectedVariant,
        variantValidation
    ]);
    return {
        stockStatus,
        variantHandler
    };
}
//# sourceMappingURL=usePackageProductItem.js.map